import { Link } from 'react-router';
import Functions from '../../../functions';
import iconFile from '../../assets/images/icon_conference.gif';
import type { ItemConference } from '../../lib/ItemUtil';
import ListBase, { type ListBaseProps } from '../lib/ListBase';
import ConferenceUtil from './ConferenceUtil';

class ConferenceList extends ListBase {
    constructor(props: ListBaseProps) {
        super(props);
        this.label = 'Conference';
        this.icon = iconFile;
    }

    renderBody() {
        const { lang } = this.props;
        const item = this.props.item as ItemConference;
        const authors = item.author.map((author) => Functions.mlang(author, lang)).join(', ');
        return (
            <>
                <Link to={this.url}>{Functions.mlang(item.title, lang)}</Link>
                <br />
                {Functions.mlang(item.conference_title, lang)} (
                <ConferenceUtil.PresentationType lang={lang} type={item.presentation_type} />)<br />
                {authors}
            </>
        );
    }
}

export default ConferenceList;
